import ReactEcharts from "echarts-for-react";
import React from "react";
import { Box, Container } from "@mui/material";

const Chart = () => {
  //   const option = {
  //     tooltip: {
  //       trigger: "item",
  //       valueFormatter: (value) => value + "%",
  //     },

  //     series: [
  //       {
  //         type: "pie",
  //         radius: ["40%", "70%"],
  //         innerWidth: "50%",
  //         selectedMode: "single",
  //         // label: {
  //         //   position: "inner",
  //         //   fontSize: 12,
  //         //   color: "#fff",
  //         //   rotate: true,
  //         //   width: 100,
  //         // },
  //         label: {
  //           show: true,
  //         },
  //         emphasis: {
  //           label: {
  //             show: true,
  //             fontSize: 40,
  //             fontWeight: "bold",
  //           },
  //         },
  //         labelLine: {
  //           show: true,
  //         },
  //         data: [
  //           { value: 15, name: "Exchange listing and airdrops" },
  //           { value: 10, name: "Resources & Business opportunities " },
  //           { value: 3, name: "Staking pool" },
  //           { value: 10, name: "Buyback  & reflect" },
  //           { value: 20, name: "Marketing" },
  //         ],
  //         color: ["#FF772A", "#ACACAC", "#00CCFE", "#FF0095", "#2BE233"],
  //       },
  //     ],
  //   };

  const option = {
    // title: {
    //   text: "Referer of a Website",
    //   subtext: "Fake Data",
    //   left: "center",
    // },
    tooltip: {
      trigger: "item",
    },
    // legend: {
    //   orient: "vertical",
    //   left: "left",
    // },
    series: [
      {
        name: "Access From",
        type: "pie",
        radius: ["40%", "70%"],
        label: {
          formatter: "  {b|{b} \n {d}%}  ",
          backgroundColor: "transparent",
          borderWidth: 1,
          borderRadius: 4,
          rich: {
            b: {
              color: "white",
              fontSize: 14,
              fontWeight: "bold",
              lineHeight: 33,
            },
          },
        },
        data: [
          { value: 35, name: "Icon token " },
          { value: 12, name: "Presale Token " },
          { value: 18, name: "Reserve Funds" },
          { value: 20, name: "Presale Token" },
          { value: 15, name: "Team & advisor" },
        ],
        color: ["#312195", "#074B9E", "#0B649E", "#5BF8FF", "#00B5F5"],
        // emphasis: {
        //   itemStyle: {
        //     shadowBlur: 10,
        //     shadowOffsetX: 0,
        //     shadowColor: "rgba(0, 0, 0, 0.5)",
        //   },
        // },
      },
    ],
  };
  return (
    <Box id="chart">
      <ReactEcharts
        option={option}
        style={{ height: 400, fontFamily: "Josefin Sans" }}
      />
    </Box>
  );
};

export default Chart;
